import React, { useState, useRef, useEffect } from "react";
import { v4 as uuid } from "uuid";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";

// assets and scss imports ⇒
import "./abhaVerification.scss";
import BadgeIcon from "@mui/icons-material/Badge";
import checkedImg from "../../../../assets/checked.png";
// project file imports(UI components) ⇒
import PrimaryButton from "../../../common/Buttons/PrimaryButton";
import OTPInput from "../../../common/OTPInput";
import Loader from "../../../UI Component/Loader/Loader";
import AbhaConfirmationDetails from "../../../common/AbhaConfirmationDetails";
import SecondaryButton from "../../../common/Buttons/SecondaryButton";
// const file imports(helper methods, etc) ⇒
import { c2cPostApiHandler } from "../../../../Util/c2cApiHandler";
import {
  GET_OR_SEND_OTP,
  GET_VERIFICATION_REQUEST,
  VERIFY_OTP,
} from "../../APIHandler/apiConstants";
import backArrow from "../../../../assets/back_arrow_gray.svg";
import { handleAbhaGenderFormat } from "../helper";
import { PROD } from "../../../common/config";
// project file imports(UI components) ⇒

// const file imports(helper methods, etc) ⇒

const AbhaVerification = (props) => {
  // const declarations ⇒
  const {
    hfrId,
    abhaNumberStep,
    existingPatientDetails,
    handleSubmitExistingPatientDetails,
    handleSubmitAbhaPatientDetails,
    handleAbhaNumberSteps,
    handleBack,
  } = props;
  const [abhaNumberInput, setAbhaNumberInput] = useState({
    first: "",
    second: "",
    third: "",
    fourth: "",
  });

  const [inputFocused, setInputFocused] = useState(null);
  const [verificationError, setVerificationError] = useState();
  const [otpResponseStatus, setOtpResponseStatus] = useState("");
  const [patientDetailsStatus, setPatientDetailsStatus] = useState("pending");
  const [selectedVerificationOption, setSelectedVerificationOption] =
    useState("");
  const [pageLoader, setPageLoader] = useState(false);
  const [transactionId, setTransactionId] = useState("");
  const [abhPatientDetails, setAbhaPatientDeatils] = useState({});
  const [otpInput, setOtpInput] = useState("");
  const [disableAbhaNumberSubmit, setDisableAbhaNumberSubmit] = useState(true);
  const [disableOtpSubmit, setDisableOtpSubmit] = useState(true);
  const [hideTimerResendBtn, setHideTimerResendBtn] = useState(false);

  const firstRef = useRef();
  const secondRef = useRef();
  const thirdRef = useRef();
  const fourthRef = useRef();

  const [linkType, setLinkType] = useState([
    {
      id: 1,
      label: "Verify with Mobile Number linked to ABHA",
      icon: <PhoneIphoneIcon className="anvv-link-icons" />,
      selected: false,
      value: "MOBILE_OTP",
    },
    {
      id: 2,
      label: "Verify with Aadhar Mobile Number linked to ABHA",
      icon: <BadgeIcon className="anvv-link-icons" />,
      selected: false,
      value: "AADHAAR_OTP",
    },
  ]);

  const abhaNumber =
    abhaNumberInput.first +
    abhaNumberInput.second +
    abhaNumberInput.third +
    abhaNumberInput.fourth;

  // life cycle methods ⇒

  useEffect(() => {
    if (abhaNumber?.length === 14) {
      setDisableAbhaNumberSubmit(false);
    } else {
      setDisableAbhaNumberSubmit(true);
    }
  }, [abhaNumber]);

  useEffect(() => {
    if (otpInput?.length < 6) {
      setDisableOtpSubmit(true);
    } else {
      setDisableOtpSubmit(false);
    }
  }, [otpInput]);

  // API Calls ⇒

  const getVerificationRequestAPICall = (auth_mode, isResendOtp) => {
    setPageLoader(true);
    let requestPayload = {
      appointment_id: uuid(),
      auth_mode: auth_mode,
      abdm_hfr_id: hfrId,
      preferred_abha_address: abhaNumber,
      auth_type: "abha-number",
    };

    const requestIdResponse = c2cPostApiHandler(
      GET_VERIFICATION_REQUEST,
      requestPayload
    );
    requestIdResponse.then(([res, err]) => {
      if (!err) {
        if (res?.data?.statusCode === 200) {
          // let payload = {
          //   request_id: res?.data?.request_id,
          //   request_type: "request_otp",
          //   patient_account_id: existingPatientDetails?.patient_account_id,
          // };
          // if (isResendOtp) {
          //   resendOTPAPICall(payload);
          // } else {
          //   getOrSendOTPAPICall(payload);
          // }

          setTransactionId(res?.data?.transaction_id);
          setPageLoader(false);
          handleAbhaNumberSteps(3);

          setHideTimerResendBtn(false);
        } else if (res?.data?.statusCode === 503) {
          setPageLoader(false);
          setOtpInput("");
          setVerificationError(res?.data?.message);
          setHideTimerResendBtn(true);
          handleAbhaNumberSteps(2);
        } else {
          handleOpenVerifyPopup();
        }
      } else {
        handleOpenVerifyPopup();
      }
    });
  };

  const resendOTPAPICall = (payload) => {
    let interval;
    const timer = setTimeout(() => {
      clearInterval(interval);
      setOtpResponseStatus("");
      handleOpenVerifyPopup();
    }, 20000);

    if (otpResponseStatus !== "complete") {
      interval = setInterval(() => {
        const otpResponse = c2cPostApiHandler(GET_OR_SEND_OTP, payload);
        otpResponse.then(([res, err]) => {
          if (!err) {
            if (res?.data?.statusCode === 200) {
              setOtpResponseStatus(res?.data?.status);
              if (res?.data?.status === "complete") {
                setTransactionId(res?.data?.transaction_id);
                clearInterval(timer);
                clearInterval(interval);
                changeOTPStatus();
              }
            }
          }
        });
      }, 1000);
    }
  };
  const getOrSendOTPAPICall = (payload) => {
    let interval;
    const timer = setTimeout(() => {
      clearInterval(interval);
      handleOpenVerifyPopup();
      setOtpResponseStatus("");
    }, 20000);

    if (otpResponseStatus !== "complete") {
      interval = setInterval(() => {
        const otpResponse = c2cPostApiHandler(GET_OR_SEND_OTP, payload);
        otpResponse.then(([res, err]) => {
          if (!err) {
            if (res?.data?.statusCode === 200) {
              setOtpResponseStatus(res?.data?.status);
              if (res?.data?.status === "complete") {
                setTransactionId(res?.data?.transaction_id);
                setPageLoader(false);
                handleAbhaNumberSteps(3);
                clearInterval(timer);
                clearInterval(interval);
                changeOTPStatus();
              }
            }
          }
        });
      }, 1000);
    }
  };

  const verifyOtpAPICall = (payload) => {
    setPageLoader(true);
    const verifyOtpResponse = c2cPostApiHandler(VERIFY_OTP, payload);
    verifyOtpResponse.then(([res, err]) => {
      if (!err) {
        if (res?.data?.statusCode === 200) {
          if (res?.data?.request_id) {
            // let payload = {
            //   request_id: res?.data?.request_id,
            //   request_type: "verify_otp",
            //   patient_account_id: existingPatientDetails?.patient_account_id,
            // };
            // getAbhaDetailsAPICall(payload);
            let details = {
              name: res?.data?.data?.fullName,
              address: res?.data?.data?.address,
              state: res?.data?.data?.stateName,
              gender: handleAbhaGenderFormat(res?.data?.data?.gender),
              dob: `${
                res?.data?.data?.dayOfBirth ? res?.data?.data?.dayOfBirth : "01"
              }-${
                res?.data?.data?.monthOfBirth
                  ? res?.data?.data?.monthOfBirth
                  : "01"
              }-${res?.data?.data?.yearOfBirth}`,
              preferred_abha_address: res?.data?.data?.preferredAbhaAddress
                ? res?.data?.data?.preferredAbhaAddress?.split("@")[0]
                : "",
            };
            setAbhaPatientDeatils(details);
            setPageLoader(false);
            handleAbhaNumberSteps(4);
          }
        } else {
          handleOpenVerifyPopup();
        }
      } else {
        handleOpenVerifyPopup();
      }
    });
  };
  const getAbhaDetailsAPICall = (payload) => {
    let interval;
    const timer = setTimeout(() => {
      clearInterval(interval);
      setOtpResponseStatus("");
      handleOpenVerifyPopup();
    }, 20000);

    if (patientDetailsStatus !== "complete") {
      interval = setInterval(() => {
        const patientDetailsResponse = c2cPostApiHandler(
          GET_OR_SEND_OTP,
          payload
        );
        patientDetailsResponse.then(([res, err]) => {
          if (!err) {
            if (res?.data?.statusCode === 200) {
              setPatientDetailsStatus(res?.data?.status);
              if (res?.data?.status === "complete") {
                clearInterval(interval);
                clearInterval(timer);
                let details = {
                  name: res?.data?.patient_details?.name,
                  address: res?.data?.patient_details?.address?.line,
                  state: res?.data?.patient_details?.address?.state,
                  gender: handleAbhaGenderFormat(
                    res?.data?.patient_details?.gender
                  ),
                  dob: `${
                    res?.data?.patient_details?.dayOfBirth
                      ? res?.data?.patient_details?.dayOfBirth
                      : "01"
                  }-${
                    res?.data?.patient_details?.monthOfBirth
                      ? res?.data?.patient_details?.monthOfBirth
                      : "01"
                  }-${res?.data?.patient_details?.yearOfBirth}`,
                  preferred_abha_address: res?.data?.patient_details?.id
                    ? res?.data?.patient_details?.id?.split("@")[0]
                    : "",
                };
                setAbhaPatientDeatils(details);
                setPageLoader(false);
                handleAbhaNumberSteps(4);
                setTimeout(() => {
                  setOtpResponseStatus("");
                }, 2000);
              }
            }
          }
        });
      }, 1000);
    }
  };

  // Actions ⇒

  const handleAadharInput = (e, position) => {
    let value = e.target.value;

    if (position === "first" && value.length > 2) {
      value = value.slice(0, 2);
    }
    if (value.length <= 4) {
      setAbhaNumberInput({
        ...abhaNumberInput,
        [position]: value,
      });
    }
    switch (position) {
      case "first":
        if (value.length === 2) {
          secondRef.current.focus();
        }
        break;
      case "second":
        if (value.length === 4) {
          thirdRef.current.focus();
        }
        break;
      case "third":
        if (value.length === 4) {
          fourthRef.current.focus();
        }
        break;
      default:
        break;
    }
  };

  const handleOnKeyDown = (e) => {
    const pressedKey = e.key;
    switch (pressedKey) {
      case "Backspace":
      case "Delete": {
        if (abhaNumberInput[inputFocused]?.length === 0) {
          switch (inputFocused) {
            case "first":
              break;
            case "second":
              firstRef.current.focus();
              break;
            case "third":
              secondRef.current.focus();
              break;
            case "fourth":
              thirdRef.current.focus();
              break;
            default:
              break;
          }
        }
        break;
      }
      default: {
        if (
          pressedKey === "e" ||
          pressedKey === "+" ||
          pressedKey === "-" ||
          pressedKey === "." ||
          pressedKey === "ArrowUp" ||
          pressedKey === "ArrowDown"
        ) {
          e.preventDefault();
        }
        break;
      }
    }
  };

  const handleOnPaste = (e) => {
    e.preventDefault();
    let copiedValue = e.clipboardData.getData("text/plain");
    let value = copiedValue.replaceAll(" ", "");
    if (value.trim().length === 12) {
      if (!isNaN(value)) {
        const result = value.match(/.{1,4}/g) || [];
        setAbhaNumberInput({
          first: result[0],
          second: result[1],
          third: result[2],
          fourth: result[3],
        });
        fourthRef.current.focus();
      }
    }
  };

  const handleOnFocus = (position) => {
    setInputFocused(position);
  };

  const handleAbhaVerificationOption = (selectedValue) => {
    setVerificationError("");
    setOtpResponseStatus("");
    setPatientDetailsStatus("");
    setSelectedVerificationOption(selectedValue?.value);
    getVerificationRequestAPICall(selectedValue?.value, false);
  };

  const handleOpenVerifyPopup = () => {
    setPageLoader(false);
    setOtpInput("");
    setVerificationError("OTP verification failed. Please try again");
    handleAbhaNumberSteps(2);
  };
  const changeOTPStatus = () => {
    setTimeout(() => {
      setOtpResponseStatus("");
    }, 2000);
  };

  const handleVerifyOTP = () => {
    let payload = {
      appointment_id: uuid(),
      auth_code: otpInput,
      transaction_id: transactionId,
      auth_mode: selectedVerificationOption,
      auth_type: "abha-number",
    };

    verifyOtpAPICall(payload);
  };

  const handleResendOTP = () => {
    setOtpResponseStatus("");
    getVerificationRequestAPICall(selectedVerificationOption, true);
  };

  const handleAbhaNumberSubmit = () => {
    if (abhaNumber?.length === 14) {
      handleAbhaNumberSteps(2);
    }
  };

  const handleOtpSubmit = () => {
    if (otpInput?.length === 6) {
      handleVerifyOTP();
    }
  };

  const handleOnChange = (otpInput) => {
    setOtpInput(otpInput);
  };

  const getAbhaAddress = (abhaAddress) => {
    return `${
      abhaAddress + (process.env.REACT_APP_ENV !== PROD ? "@sbx" : "@abdm")
    }`;
  };

  // Create UI ⇒

  const abhaAadharInputUI = () => {
    return (
      <div className="anvv-pd">
        <div className="anvv-input-label">Enter ABHA Number</div>
        <div className="anvv-input-container-view">
          <div className="anvv-input-first-container">
            <input
              className="anvv-input"
              placeholder="xx"
              maxLength={2}
              type="number"
              value={abhaNumberInput.first}
              onChange={(e) => handleAadharInput(e, "first")}
              ref={firstRef}
              onKeyDown={handleOnKeyDown}
              onFocus={() => handleOnFocus("first")}
              onPaste={handleOnPaste}
            />
          </div>
          <div className="anvv-input-container">
            <input
              className="anvv-input"
              placeholder="xxxx"
              maxLength={4}
              type="number"
              value={abhaNumberInput.second}
              onChange={(e) => handleAadharInput(e, "second")}
              ref={secondRef}
              onKeyDown={handleOnKeyDown}
              onFocus={() => handleOnFocus("second")}
              onPaste={handleOnPaste}
            />
          </div>
          <div className="anvv-input-container">
            <input
              className="anvv-input"
              placeholder="xxxx"
              maxLength={4}
              type="number"
              value={abhaNumberInput.third}
              onChange={(e) => handleAadharInput(e, "third")}
              ref={thirdRef}
              onKeyDown={handleOnKeyDown}
              onFocus={() => handleOnFocus("third")}
              onPaste={handleOnPaste}
            />
          </div>
          <div className="anvv-input-container">
            <input
              className="anvv-input"
              placeholder="xxxx"
              maxLength={4}
              type="number"
              value={abhaNumberInput.fourth}
              onChange={(e) => handleAadharInput(e, "fourth")}
              ref={fourthRef}
              onKeyDown={handleOnKeyDown}
              onFocus={() => handleOnFocus("fourth")}
              onPaste={handleOnPaste}
            />
          </div>
        </div>
        <div className="anvv-number-count">14 digit ABHA number</div>
        {abhaNumberContinueBtn(handleAbhaNumberSubmit, disableAbhaNumberSubmit)}
      </div>
    );
  };

  const verifywithMobileNumberUi = () => {
    return (
      <div className="anvv-verify-with-number-wrapper anvv-pd">
        <div className="anvv-enter-otp-heading">Enter OTP</div>
        <div className="anvv-verify-title">
          {selectedVerificationOption === "MOBILE_OTP"
            ? "We just sent an OTP on the mobile number which is linked to the ABHA Address"
            : "We just sent an OTP on the Aadhar mobile number which is linked to ABHA"}
        </div>
        <div className="anvv-title-with-number"></div>
        <div className="anvv-otp-input">
          <OTPInput
            autoFocus
            hasError={false}
            // errorMessage={errorMessage}
            timerUnit={1}
            hideTimerResendBtn={hideTimerResendBtn}
            onChangeOTP={handleOnChange}
            handleResendOTP={handleResendOTP}
          />
        </div>
        {abhaNumberContinueBtn(handleOtpSubmit, disableOtpSubmit)}
      </div>
    );
  };

  const linkPatientAbhaNumberUi = () => {
    return (
      <div className="anvv-link-patient-abha-no-container anvv-pd">
        <div className="anvv-link-label">Link With:</div>
        <div className="anvv-link-options-wrapper">
          {linkType.map((item, ind) => (
            <div
              className={
                "anvv-link-option-list " +
                (item.selected ? "anvv-link-option-list-selected" : "")
              }
              key={ind}
              onClick={() => {
                handleAbhaVerificationOption(item);
              }}
            >
              <div
                className={
                  "anvv-link-title " +
                  (item.selected ? "anvv-link-title-selected" : "")
                }
              >
                {item.icon}
                <div>{item.label}</div>
              </div>
              {item.selected && <img src={checkedImg} alt="" />}
            </div>
          ))}
        </div>
        {verificationError && (
          <div className="anvv-link-error">{verificationError}</div>
        )}
      </div>
    );
  };

  const abhaNumberContinueBtn = (handleClick, disableBtn) => {
    return (
      <div className="anvv-continue-btn-wrapper">
        <PrimaryButton
          title="Continue"
          disabled={disableBtn}
          handleButtonClick={handleClick}
        />
      </div>
    );
  };

  const abhaConfirmationSection = () => {
    return (
      <div className="pavc-aadhar-conf-section">
        <div className="pavc-back-btn-container">
          <img
            src={backArrow}
            alt=""
            className="pavc-back-btn"
            onClick={handleBack}
          />
        </div>
        <div className="pavc-aadhar-conf-section-heading">
          <h5>Confirmation!</h5>
          <p>
            Patient Details will be updated as per <br />
            the ABHA Address "
            <span className="pavc-aadhar-conf-section-heading">
              {getAbhaAddress(abhPatientDetails?.preferred_abha_address)}
            </span>
            ".Do you want to continue ?
          </p>
        </div>
        <AbhaConfirmationDetails
          appointmentDetails={existingPatientDetails}
          abhPatientDetails={abhPatientDetails}
        />
        <div>
          <div className="pd-abha-qr-data-confirmation-footer-container">
            <div className="pd-abha-qr-data-confirmation-footer-left-btn">
              <SecondaryButton
                title="No"
                handleButtonClick={() =>
                  handleSubmitExistingPatientDetails(
                    abhPatientDetails?.preferred_abha_address,
                    abhPatientDetails?.ABHANumber
                  )
                }
              />
            </div>
            <div className="pd-abha-qr-data-confirmation-footer-right-btn">
              <PrimaryButton
                title="Yes"
                handleButtonClick={() =>
                  handleSubmitAbhaPatientDetails(abhPatientDetails)
                }
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="abha-number-verification-container">
      {pageLoader && <Loader />}
      {abhaNumberStep === 1 && abhaAadharInputUI()}
      {abhaNumberStep === 2 && linkPatientAbhaNumberUi()}
      {abhaNumberStep === 3 && verifywithMobileNumberUi()}
      {abhaNumberStep === 4 && abhaConfirmationSection()}
    </div>
  );
};

export default AbhaVerification;
